mutation WhatsAppSyncInitiate($input: WhatsAppSyncInitiateInput!) {
    whatsAppSyncInitiate(input: $input)
}
